module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "Solana.3c790cbc.svg";